import { useMemo } from 'react';
import { QueryResult, useQuery } from 'react-query';
import { AccountType, ClosedReason, RefDataClosedReasonsApi } from 'eve-account-client';
import { useConfiguration } from './BaseApi';

export const useRefDataClosedReasonsApi = (): RefDataClosedReasonsApi => {
  const configuration = useConfiguration();
  const api = useMemo(() => new RefDataClosedReasonsApi(configuration), [configuration]);
  return api;
};

const getClosedReasons = async (accountType: AccountType, api: RefDataClosedReasonsApi): Promise<ClosedReason[]> => {
  const request = api.getClosedReasons({ accountType });

  return (await request).map((reason): ClosedReason => ({ ...reason }));
};

export const useClosedReasonsQuery = (accountType: AccountType): QueryResult<ClosedReason[], Error | Response> => {
  const api = useRefDataClosedReasonsApi();

  return useQuery<ClosedReason[], Error | Response>(
    ['accountType', accountType],
    () => getClosedReasons(accountType, api),
    { enabled: Boolean(accountType) },
  );
};
